/* eslint-disable tailwindcss/migration-from-tailwind-2 */
import { useState } from 'react';
import { useFetcher } from 'react-router';

import TickIcon from '~/assets/icons/Tick';
import Image from '~/components/Image';
import Link from '~/components/Link';

export default function Splash() {
  return (
    <Backdrop>
      <div className="mt-6 flex size-full max-h-dvh flex-col items-center justify-around gap-5 md:mt-0 md:flex-row">
        <div className="flex size-full w-full flex-col items-center gap-4 md:w-[456px] md:justify-center">
          <Text />
          <EmailCaptureForm />
        </div>
        <div className="-z-30 grid max-h-[400px] grid-cols-3 gap-2 overflow-clip object-cover md:max-h-[800px] md:max-w-[552px]">
          <Image
            className="object-[0%_45px] md:object-[0%_-72px]"
            src="https://cms-cdn.thesolesupplier.co.uk/bolt/assets/images/regional_homepage_splash_1.png"
            alt="Homepage splash"
          />
          <Image
            className="object-top md:object-[0%_-218px]"
            src="https://cms-cdn.thesolesupplier.co.uk/bolt/assets/images/regional_homepage_splash_2.png"
            alt="Homepage splash"
          />
          <Image
            className="object-[0%_20px] md:object-[0%_-120px]"
            src="https://cms-cdn.thesolesupplier.co.uk/bolt/assets/images/regional_homepage_splash_3.png"
            alt="Homepage splash"
          />
        </div>
      </div>
    </Backdrop>
  );
}

function Backdrop({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative flex w-full items-center justify-center px-4 md:p-0 ">
      <Image
        loading="eager"
        className="absolute -z-50 hidden size-full object-cover md:block"
        alt="home-page-marketplace-backdrop"
        src="https://cms-cdn.thesolesupplier.co.uk/bolt/assets/images/splash_homepage_adidas_2024_desktop.jpg"
      />
      <Image
        loading="eager"
        className="absolute -z-50 block size-full object-cover md:hidden"
        alt="home-page-marketplace-backdrop"
        src="https://cms-cdn.thesolesupplier.co.uk/bolt/assets/images/splash_homepage_adidas_2024_desktop.jpg"
      />
      <div className="absolute inset-0 -z-40 bg-black opacity-40"></div>
      {children}
    </div>
  );
}

function Text() {
  return (
    <div className="flex w-full flex-col justify-center gap-2 bg-dark-background/65 p-6 tracking-wide ">
      <p className="text-3xl text-white md:text-5xl md:leading-tight">
        Vergleiche einzelhändler an einem ort
      </p>
      <p className="text-2xl text-golden-syrup md:text-3xl md:leading-tight">
        Entdecke dein nächstes
        <br />
        Paar auf The Sole Supplier
      </p>
    </div>
  );
}

function EmailCaptureForm() {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const fetcher = useFetcher();

  const handleSubmit = (e: React.FormEvent) => {
    if (!isValidEmail) return e.preventDefault();

    setIsSubmitted(true);
  };

  return isSubmitted ? (
    <EmailCaptureSuccess />
  ) : (
    <div>
      <fetcher.Form
        className="flex w-full gap-2"
        onSubmit={handleSubmit}
        action="/bolt/email-capture/"
        method="post"
      >
        <input
          className="flex-grow rounded-lg border border-gray-300 p-2"
          type="email"
          name="email"
          placeholder="E-Mail für die Warteliste eingeben"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button
          className={`h-12 min-w-12 rounded-lg text-white md:w-32 ${isValidEmail ? 'bg-forest' : 'bg-grey-hide'}`}
          type="submit"
        >
          <span className="md:hidden">OK</span>
          <span className="hidden md:inline">Einreichen</span>
        </button>
      </fetcher.Form>
      <TermsParagraph />
    </div>
  );
}

function TermsParagraph() {
  return (
    <p className="mt-2 text-xs leading-5 text-white">
      {'Wenn sie fortfahren, stimmen sie unseren '}
      <Link to="/terms-and-conditions/" className="underline">
        allgemeinen geschäftsbedingungen
      </Link>
      {' und '}
      <a
        href="https://products.privasee.io/privacy-portal/64ac2c059f43880013f2faf0"
        className="underline"
      >
        datenschutzrichtlinien
      </a>
      {' zu.'}
    </p>
  );
}

function EmailCaptureSuccess() {
  return (
    <div className="flex h-24 w-full items-center gap-4 bg-dark-background/65 px-4">
      <TickIcon height="43" width="43" fill="green" />
      <p className="text-white">
        Danke, Sie stehen auf der Warteliste. Wir benachrichtigen Sie per
        E-Mail, sobald die Website online ist.
      </p>
    </div>
  );
}
